import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications-setting',
  templateUrl: './notifications-setting.component.html',
  styleUrls: ['./notifications-setting.component.scss']
})
export class NotificationsSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
